// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20ekK","tabsBox":"styles_tabsBox__3Ur4n","createButton":"styles_createButton__2TW4B"};